/******************************************
 * ip-redirect.js - Geoptimaliseerd voor UK Store
 ******************************************/

/**
 * HELPER FUNCTIONS
 */

// 1. Cookie zetten (session cookie)
function setCookie(name, value) {
  // Session cookie: geen expire-datum, verloopt zodra de browser/tab wordt gesloten
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
}

// 2. Cookie uitlezen
function getCookie(name) {
  return document.cookie.split('; ').reduce((acc, cur) => {
    const [cookieName, cookieVal] = cur.split('=');
    return cookieName === name ? decodeURIComponent(cookieVal) : acc;
  }, '');
}

// 3. Popup tonen en vullen (aangepast voor landcode en vlag)
function showLocationPopup(countryCode, countryName, redirectDomain) {
  // Elements in de pop-up
  const countryElem       = document.getElementById('countryNameText');
  const countryButtonElem = document.getElementById('countryNameButton');
  const storeLink         = document.getElementById('goToOtherStore');
  const popup             = document.getElementById('hiddenPopup');
  const flagElem          = document.getElementById('countryPopupFlag');

  // 3a. Landnaam in de popup tonen
  if (countryElem)       countryElem.textContent = countryName;
  if (countryButtonElem) countryButtonElem.textContent = countryName.toUpperCase();

  // 3b. Vlag tonen (via FlagsAPI)
  if (flagElem && countryCode) {
    flagElem.src = `https://flagsapi.com/${countryCode}/flat/64.png`;
    flagElem.alt = `${countryName} flag`;
  } else if (flagElem) {
    // Fallback: standaard een lege vlag of placeholder
    flagElem.src = '';
    flagElem.alt = 'No flag available';
  }

  // 3c. Link aanpassen naar het juiste domein en dezelfde pagina
  if (storeLink) {
    storeLink.href =
      (redirectDomain || '#') +
      window.location.pathname +
      window.location.search +
      window.location.hash;
  }

  // 4. Popup tonen
  if (popup) {
    popup.style.display = 'flex'; // of 'block'
  }

  // 5. Cookie zetten zodat pop-up niet meer verschijnt in deze sessie
  setCookie('popupShown', 'true');
}

// 4. Popup verbergen (bij "Stay on store"-knop)
function hideLocationPopup() {
  const popup = document.getElementById('hiddenPopup');
  if (popup) {
    popup.style.display = 'none';
  }
}

/************************************************
 * HOOFDLOGICA: IP-locatie opvragen via ipapi
 ************************************************/
async function fetchCountry() {
  try {
    // 1. Controleren of de pop-up al is getoond (cookie) in deze sessie
    if (getCookie('popupShown') === 'true') {
      return; // Als 'popupShown' bestaat, niet opnieuw tonen
    }

    // 2. Check of we al een landcode en landnaam hebben (zelfde sessie/tab)
    const savedCountryCode = getCookie('lastCountryCode');
    const savedCountryName = getCookie('lastCountryName');

    if (savedCountryCode && savedCountryName) {
      // We hebben al landinformatie, dus geen nieuwe API-call nodig
      handleCountryLogic(savedCountryCode, savedCountryName);
      return;
    }

    // 3. Geen cookies gevonden: Locatie opvragen via ipapi (gebruik HTTPS als je site HTTPS is!)
    const response = await fetch('');
    if (!response.ok) {
      throw new Error('ipapi response was not ok');
    }
    const data = await response.json();

    // 4. Landcode en landnaam eruit halen (keys afhankelijk van ipapi)
    const countryCode = data.country_code; 
    const countryName = data.country_name; 

    // 5. Sla de landinfo op in session cookies, zodat we volgende keer geen IP-check hoeven te doen
    setCookie('lastCountryCode', countryCode);
    setCookie('lastCountryName', countryName);

    // 6. Verwerk de landcode-/naam zoals gewenst
    handleCountryLogic(countryCode, countryName);

  } catch (error) {
    console.error('Fout bij het ophalen van land via ipapi:', error);
    // Geen pop-up tonen bij error, of evt. fallback:
    // showLocationPopup('NL','Netherlands','https://cielo-fiora.com');
  }
}

/**
 * Verwerkt de logica voor de UK Store.
 */
function handleCountryLogic(countryCode, countryName) {
  /*
    Gewenste logica voor de UK store:
    - GB (UK) en IE (Ireland):
        Geen pop-up -> blijven op uk.cielo-fiora.com
    - AU (Australia) en NZ (New Zealand):
        Wel pop-up -> doorverwijzing naar https://au.cielo-fiora.com
    - CA en US:
        Wel pop-up -> doorverwijzing naar https://ca.cielo-fiora.com
    - Overige landen:
        Wel pop-up -> doorverwijzing naar https://cielo-fiora.com
  */

  if (countryCode === 'GB' || countryCode === 'IE') {
    // Geen pop-up tonen
    return;
  } else if (countryCode === 'AU' || countryCode === 'NZ') {
    // Toon pop-up, doorverwijzing naar AU-store
    showLocationPopup(countryCode, countryName, 'https://au.cielo-fiora.com');
  } else if (countryCode === 'CA' || countryCode === 'US') {
    // Toon pop-up, doorverwijzing naar CA-store
    showLocationPopup(countryCode, countryName, 'https://ca.cielo-fiora.com');
  } else {
    // Rest van de wereld: Toon pop-up, doorverwijzing naar general store
    showLocationPopup(countryCode, countryName, 'https://cielo-fiora.com');
  }
}

/***********************************************
 * EVENT-LISTENERS voor de pop-up-knoppen
 ***********************************************/
document.addEventListener('DOMContentLoaded', () => {
  // Knop: "Stay on store" -> popup verbergen + cookie zetten
  const stayButton = document.getElementById('stayOnStore');
  if (stayButton) {
    stayButton.addEventListener('click', () => {
      hideLocationPopup();
      setCookie('popupShown', 'true'); 
    });
  }
});

/***********************************************
 * SCRIPT INIT
 ***********************************************/
window.addEventListener('load', fetchCountry);
